import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'nanum-fontface/css/nanum-gothic.css';
import '@mdi/font/css/materialdesignicons.css';

import AxLogo from '@/assets/ax_logo.svg';

function register() {
  const files = require.context('./', true, /\.vue$/i);
  files
    .keys()
    .map(key => Vue.component((key.split('/').pop() || '').split('.')[0], files(key).default));
}

// Vue 컴포넌트를 자동으로 등록
register();

// 추가로 사용할 Component들을 등록
Vue.component('AxLogo', AxLogo);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
